<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="角色类型">
              <a-select v-model="queryParam.roleType" placeholder="请选择角色类型" allow-clear>
                <a-select-option :value="10">COSER</a-select-option>
                <a-select-option :value="20">摄影师</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="启用状态">
              <a-select v-model="queryParam.isEnabled" placeholder="请选择" allow-clear>
                <a-select-option :value="true">启用</a-select-option>
                <a-select-option :value="false">禁用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleQuery"><a-icon type="search" /> 搜索</a-button>
              <a-button style="margin-left: 8px" @click="handleReset"><a-icon type="redo" /> 重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd">新增</a-button>
      <a-button type="danger" icon="delete" @click="handleBatchDelete" :disabled="selectedRowKeys.length === 0">批量删除</a-button>
    </div>

    <a-table
      :columns="columns"
      :dataSource="dataSource"
      :pagination="pagination"
      :loading="loading"
      :rowKey="record => record.id"
      :rowSelection="{ selectedRowKeys, onChange: onSelectChange }"
      @change="handleTableChange"
    >
      <span slot="isEnabledSlot" slot-scope="text">
        <a-badge :status="text ? 'success' : 'error'" />
        {{ text ? '启用' : '禁用' }}
      </span>
      <span slot="actionSlot" slot-scope="text, record">
        <a @click="handleEdit(record)">修改</a>
        <a-divider type="vertical" />
        <a-popconfirm title="确定删除吗？" @confirm="handleDelete(record)">
          <a style="color: red">删除</a>
        </a-popconfirm>
        <a-divider type="vertical" />
        <a @click="showQrcode(record)">二维码</a>
      </span>
    </a-table>

    <!-- 新增/修改弹窗 -->
    <a-modal
      :title="formTitle"
      :visible="formVisible"
      :confirmLoading="formLoading"
      :width="640"
      @ok="handleFormOk"
      @cancel="handleFormCancel"
    >
      <a-spin :spinning="formLoading">
        <a-form :form="form" layout="vertical">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item label="角色类型">
                <a-select v-decorator="['roleType', { rules: [{ required: true, message: '请选择角色类型' }] }]" placeholder="请选择角色类型">
                  <a-select-option :value="10">COSER</a-select-option>
                  <a-select-option :value="20">摄影师</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="等级">
                <a-select v-decorator="['level', { rules: [{ required: true, message: '请选择等级' }] }]" placeholder="请选择等级">
                  <a-select-option :value="1">LV1</a-select-option>
                  <a-select-option :value="2">LV2</a-select-option>
                  <a-select-option :value="3">LV3</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item label="等级名称">
                <a-input v-decorator="['levelName']" placeholder="例如：初级COSER" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="积分奖励">
                <a-input-number v-decorator="['scoreReward', { initialValue: 0 }]" :min="0" placeholder="审批通过后赠送的积分" style="width: 100%" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item label="排序">
                <a-input-number v-decorator="['sort', { initialValue: 0 }]" :min="0" placeholder="排序值越小越靠前" style="width: 100%" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="启用状态">
                <a-switch v-decorator="['isEnabled', { valuePropName: 'checked', initialValue: true }]" checked-children="启用" un-checked-children="禁用" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-form-item label="等级图标URL">
            <a-input v-decorator="['levelIcon']" placeholder="等级图标链接" />
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>

    <!-- 二维码弹窗 -->
    <a-modal
      title="角色申请二维码"
      :visible="qrcodeVisible"
      :footer="null"
      :width="400"
      @cancel="qrcodeVisible = false"
    >
      <div style="text-align: center; padding: 20px">
        <img v-if="qrcodeImage" :src="qrcodeImage" style="width: 280px; height: 280px; display: block; margin: 0 auto;" alt="二维码" />
        <a-empty v-else description="暂无二维码" />
        <p style="margin-top: 12px; color: #999;">扫码后可进入角色申请页面</p>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import { getRoleLevelList, saveRoleLevel, deleteRoleLevel, getRoleQrcode } from '@/api/community/communityGroup/communityRoleQrcode'

export default {
  name: 'CommunityRoleLevelConfig',
  data() {
    return {
      queryParam: { roleType: undefined, isEnabled: undefined },
      dataSource: [],
      loading: false,
      pagination: {
        current: 1, pageSize: 10, total: 0, showSizeChanger: true, showQuickJumper: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTotal: (total) => '共 ' + total + ' 条'
      },
      selectedRowKeys: [], selectedRows: [],
      formVisible: false, formTitle: '', formLoading: false,
      form: this.$form.createForm(this),
      qrcodeVisible: false, qrcodeImage: '',
      columns: [
        { title: '角色类型', dataIndex: 'roleTypeName', align: 'center' },
        { title: '等级', dataIndex: 'level', align: 'center', customRender: (text) => 'LV' + text },
        { title: '等级名称', dataIndex: 'levelName', align: 'center' },
        { title: '积分奖励', dataIndex: 'scoreReward', align: 'center' },
        { title: '排序', dataIndex: 'sort', align: 'center' },
        { title: '启用状态', dataIndex: 'isEnabled', align: 'center', scopedSlots: { customRender: 'isEnabledSlot' } },
        { title: '操作', dataIndex: 'action', align: 'center', scopedSlots: { customRender: 'actionSlot' } }
      ]
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      const params = Object.assign({}, this.queryParam, {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      })
      getRoleLevelList(params).then(res => {
        if (res.success && res.data) {
          this.dataSource = res.data.records || []
          this.pagination.total = res.data.total || 0
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleQuery() {
      this.pagination.current = 1
      this.loadData()
    },
    handleReset() {
      this.queryParam = { roleType: undefined, isEnabled: undefined }
      this.handleQuery()
    },
    onSelectChange(rowKeys, rows) {
      this.selectedRowKeys = rowKeys
      this.selectedRows = rows
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    handleAdd() {
      this.formTitle = '新增角色等级'
      this.formVisible = true
      this.formLoading = false
      this.$nextTick(() => {
        this.form.resetFields()
      })
    },
    handleEdit(record) {
      this.formTitle = '修改角色等级'
      this.formVisible = true
      this.formLoading = false
      this.$nextTick(() => {
        this.form.setFieldsValue({
          roleType: record.roleType,
          level: record.level,
          levelName: record.levelName,
          levelIcon: record.levelIcon,
          scoreReward: record.scoreReward,
          sort: record.sort,
          isEnabled: record.isEnabled
        })
      })
    },
    handleFormOk() {
      this.form.validateFields((err, values) => {
        if (err) return
        this.formLoading = true
        saveRoleLevel(values).then(res => {
          if (res.success) {
            this.$message.success('保存成功')
            this.formVisible = false
            this.loadData()
          } else {
            this.$message.error(res.message || '保存失败')
          }
        }).catch(() => {
          this.$message.error('保存失败')
        }).finally(() => {
          this.formLoading = false
        })
      })
    },
    handleFormCancel() {
      this.formVisible = false
    },
    handleDelete(record) {
      deleteRoleLevel({ ids: [record.id] }).then(res => {
        if (res.success) {
          this.$message.success('删除成功')
          this.loadData()
        } else {
          this.$message.error(res.message || '删除失败')
        }
      }).catch(() => {
        this.$message.error('删除失败')
      })
    },
    handleBatchDelete() {
      const that = this
      this.$confirm({
        title: '确定删除选中的 ' + this.selectedRowKeys.length + ' 条记录吗？',
        onOk() {
          deleteRoleLevel({ ids: that.selectedRowKeys }).then(res => {
            if (res.success) {
              that.$message.success('批量删除成功')
              that.selectedRowKeys = []
              that.loadData()
            } else {
              that.$message.error(res.message || '批量删除失败')
            }
          }).catch(() => {
            that.$message.error('批量删除失败')
          })
        }
      })
    },
    showQrcode(record) {
      this.qrcodeImage = ''
      this.qrcodeVisible = true
      getRoleQrcode({ configId: record.id }).then(res => {
        if (res.success && res.data) {
          this.qrcodeImage = res.data
        } else {
          this.$message.error(res.message || '获取二维码失败')
        }
      }).catch(() => {
        this.$message.error('生成二维码失败')
      })
    }
  }
}
</script>

<style scoped>
</style>